import { useRef } from "react";
import { Pic } from "../Pic";

const POSTERS = [
  { src: "/images/poster-05.jpg", alt: "Game Show Loco poster", rot: -9, x: -22, y: 18 },
  { src: "/images/poster-04.jpg", alt: "Music Bingo poster", rot: 0, x: 0, y: 0 },
  { src: "/images/poster-02.jpg", alt: "Pop Culture Trivia poster", rot: 9, x: 22, y: 18 },
];

export const MarqueeBulbs = () => (
  <div aria-hidden data-testid="marquee-bulbs" className="pointer-events-none absolute inset-x-0 top-0 flex h-3 items-center justify-around px-2">
    {Array.from({ length: 36 }).map((_, i) => <span key={i} className="marquee-bulb" style={{ "--i": i % 3, background: ["#FFC20E", "#ffffff", "#149B9E"][i % 3], boxShadow: `0 0 6px ${["rgba(255,194,14,0.7)", "rgba(255,255,255,0.8)", "rgba(20,155,158,0.7)"][i % 3]}` }} />)}
  </div>
);

export const PosterFan = () => {
  const ref = useRef(null);
  const onMove = (e) => {
    const el = ref.current; if (!el || window.matchMedia("(hover: none)").matches) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty("--px", ((e.clientX - r.left) / r.width - 0.5).toFixed(3));
    el.style.setProperty("--py", ((e.clientY - r.top) / r.height - 0.5).toFixed(3));
  };
  const reset = () => { const el = ref.current; if (el) { el.style.setProperty("--px", 0); el.style.setProperty("--py", 0); } };
  return (
    <div ref={ref} onMouseMove={onMove} onMouseLeave={reset} data-testid="experiences-poster-fan" className="poster-fan relative mx-auto h-[300px] w-full max-w-[420px] sm:h-[380px] lg:h-[460px]">
      {POSTERS.map((p, i) => (
        <div key={p.src} className="poster-card absolute left-1/2 top-1/2 w-[46%] sm:w-[48%]" style={{ "--rot": `${p.rot}deg`, "--x": `${p.x}%`, "--y": `${p.y}px`, "--depth": i === 1 ? 1.6 : 1, "--i": i, zIndex: i === 1 ? 2 : 1 }}>
          <Pic src={p.src} alt={p.alt} priority={i === 1} sizes="220px" className="aspect-[2/3] w-full rounded-2xl object-cover shadow-[0_30px_60px_-25px_rgba(0,0,0,0.5)] ring-1 ring-black/10" />
        </div>
      ))}
    </div>
  );
};
